export const ALL_SKILLS = [
  'Time Management',
  'Conflict Resolution',
  'Analytical Thinking',
  'Adaptability',
  'Networking',
  'Presentation Skills',
  'Technical Writing',
  'Problem Solving',
  'Research Skills',
  'Interpersonal Skills',
  'Sales Strategy',
  'Market Analysis',
  'Negotiation Skills',
  'Process Improvement',
  'Creativity',
  'Teamwork',
  'Leadership',
  'Attention to Detail',
  'Project Management',
  'Customer Service',
  'Data Analysis',
  'Public Speaking',
  'Collaboration',
  'Decision Making',
  'Critical Thinking',
  'Organization',
  'Multitasking',
  'Strategic Planning',
  'Resourcefulness',
  'Self-Motivation',
  'Emotional Intelligence',
]; 